module.exports = __webpack_public_path__ + "img/check-white.9b8936c0.svg";